"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfDeviceTokenAckDto = instanceOfDeviceTokenAckDto;
exports.DeviceTokenAckDtoFromJSON = DeviceTokenAckDtoFromJSON;
exports.DeviceTokenAckDtoFromJSONTyped = DeviceTokenAckDtoFromJSONTyped;
exports.DeviceTokenAckDtoToJSON = DeviceTokenAckDtoToJSON;
exports.DeviceTokenAckDtoToJSONTyped = DeviceTokenAckDtoToJSONTyped;
/**
 * Check if a given object implements the DeviceTokenAckDto interface.
 */
function instanceOfDeviceTokenAckDto(value) {
    if (!('message' in value) || value['message'] === undefined)
        return false;
    return true;
}
function DeviceTokenAckDtoFromJSON(json) {
    return DeviceTokenAckDtoFromJSONTyped(json, false);
}
function DeviceTokenAckDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'message': json['message'],
    };
}
function DeviceTokenAckDtoToJSON(json) {
    return DeviceTokenAckDtoToJSONTyped(json, false);
}
function DeviceTokenAckDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'message': value['message'],
    };
}
